export default __webpack_public_path__ + "static/media/OEM.a651d5f9.png";